module.exports = __webpack_public_path__ + "img/status-postedfb.4ce46449.png";